export const TIMELINE_TYPES = {
  TRAINER_LOGS_WORKOUT: 'trainer-logs-workout',
  CLIENT_LOGS_MEAL_PRE_TRANSFORMATION: 'client-logs-pre-transformation-',
  TRAINER_ADD_GOAL: 'trainer-add-goal',
  TRAINER_ADD_PROGRESS_PHOTO: 'trainer-add-progress-images',
  TRAINER_ADD_NOTE: 'trainer-add-note',
  TRAINER_ADD_ASSESSMENT: 'trainer-add-assessment',
  TRAINER_ASSIGN_NUTRITION: 'trainer-assign-nutrition',
  TRAINER_ASSIGN_WORKOUT: 'trainer-assign-workout',
  CLIENT_KICKSTART_QUESTIONNAIRE: 'client-finishes-kickstart-questionnaire'
};

export const TIMELINE_ASSIGNER_TYPES = {
  TRAINER: 'trainer',
  CLIENT: 'client'
};

export const TIMELINE_LIMIT = 30;
